export default __webpack_public_path__ + "img/dMjQpXXz.b21d8584.svg";